import appStore from 'store';
import api from './api';

const store = {
  namespaced: true,
  state: {
    shareSummary: []
  },
  getters: {
    shareSummary: state => {
      return state.shareSummary;
    }
  },
  mutations: {
    setShareSummary(state, data) {
      state.shareSummary = data;
    }
  },
  actions: {
    // eslint-disable-next-line
    getShareSummary({ commit }, query) {
      api.getShareSummary(query).then(({ data }) => {
        commit('setShareSummary', data);
      });
    }
  }
};

appStore.registerModule('miningSummary', store);
